import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import type { CronjobBehaviors } from "./types.js";
import { checkForValidationErrors } from "../../../base/index.js";

export const apiCronjobBehaviors = (
  client: MittwaldAPIV2Client,
): CronjobBehaviors => ({
  find: async (cronjobId) => {
    const response = await client.cronjob.getCronjob({ cronjobId });

    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (projectId, query) => {
    const response = await client.cronjob.listCronjobs({
      queryParameters: query,
      projectId,
    });

    assertStatus(response, 200);

    return {
      items: response.data,
    };
  },

  create: async (projectId, data) => {
    const response = await client.cronjob.createCronjob({
      projectId,
      data,
    });

    const validationErrors = checkForValidationErrors(response);
    if (validationErrors) {
      return validationErrors;
    }

    assertStatus(response, 201);

    return response.data;
  },

  update: async (cronjobId, data) => {
    const response = await client.cronjob.updateCronjob({
      cronjobId,
      data,
    });

    const validationErrors = checkForValidationErrors(response);
    if (validationErrors) {
      return validationErrors;
    }

    assertStatus(response, 204);
  },

  updateAppId: async (cronjobId, data) => {
    const response = await client.cronjob.updateCronjobAppId({
      cronjobId,
      data,
    });

    assertStatus(response, 204);
  },

  delete: async (cronjobId) => {
    const response = await client.cronjob.deleteCronjob({ cronjobId });

    assertStatus(response, 204);
  },

  trigger: async (cronjobId) => {
    const response = await client.cronjob.createExecution({ cronjobId });

    assertStatus(response, 201);
  },
});
